'use client';

import useEmblaCarousel from 'embla-carousel-react';
import { useEffect, useCallback } from 'react';
import { CustomImage as Image } from '../shared';
import styles from './RareCarousel.module.css';

// Custom Arrow Icon Component
const ArrowIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
  >
    <path
      d="M10.8711 16.0046L17.5378 10.1712L10.8711 4.33789"
      stroke="#55544F"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.5391 10.1719H2.53906"
      stroke="#55544F"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const RareCarousel = ({
  items,
}: {
  items: ReadonlyArray<Record<string, string | boolean | undefined>>;
}) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({
      align: 'center',
      loop: true,
      slidesToScroll: 1,
    });

    const scrollPrev = useCallback(() => {
      if (emblaApi) emblaApi.scrollPrev();
    }, [emblaApi]);

    const scrollNext = useCallback(() => {
      if (emblaApi) emblaApi.scrollNext();
    }, [emblaApi]);

    useEffect(() => {
      if (document) {
        const images = document.getElementsByTagName('img');
        for (const item of images) {
          item.onload = () => {
            item.style.background = 'transparent';
          };
        }
      }
    }, []);

    return (
      <div className={styles.root}>
        <div className="embla" ref={emblaRef}>
          <div className="embla__container">
            {items.map((item, index) => (
              <div key={index} className="embla__slide">
                <div className="image-container">
                  <Image
                    fill
                    sizes="(min-width: 1024px) 70vw, 100vw"
                    src={item.src as string}
                    alt={item.alt as string}
                    className={`main-image ${
                      item.objectPositionBottom ? 'object-bottom' : ''
                    } ${index === 4 ? 'cover-image' : ''}`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div className="navigation">
          <button
            className="nav-button prev"
            onClick={scrollPrev}
            aria-label="Previous image"
          >
            <ArrowIcon />
          </button>
          <button
            className="nav-button next"
            onClick={scrollNext}
            aria-label="Next image"
          >
            <ArrowIcon />
          </button>
        </div>
      </div>
    );
};
